/* eslint-disable no-unused-vars */
import { Scene, Input } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, setLastMovement, directionHandler, randomDirection, lightstickHandler } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import SettingsButton from "../../phaser/components/settingsButton";
import { addButtonMove } from "../../phaser/components/buttonMove";
import ButtonPressed from "../../phaser/components/buttonPressed";
import HealthBar from "../../phaser/components/healthBar";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";

let characterSelected;
let objNames = {};
let upRectangle;
let downRectangle;
let leftRectangle;
let rightRectangle;
let gameSettings;
let defaultSettings = 1;
let hearts = 1;
let totalHearts = 1;
let redHeartsObject = [];
let blackHeartsObject = [];
let cursors;
let instructionsHandler = 0;
let enemyShow = null;
let enemyYShow = null;
let intervalEnemy = null;
let startKill = false;
let countFinal = 0;
let scrollFactor = 2;
let hasLightstick = false;
let width = 0;
let totalTimer = 80000;
let isPause = false;
let allMembers = [];
let lastCoordenates = null;


export default class Game9 extends Scene {

    constructor() {
        super({ key: "Game9" });
    }
    init(data) {
        characterSelected = data.characterSelected;
        lastCoordenates = data.lastCoordenates;
        this.enemies = {};
        this.bulletRight = {};
        // hasLightstick = false;
        redHeartsObject = [];
        blackHeartsObject = [];
        hearts = 1;
        clearInterval(intervalEnemy);
        clearInterval(this.countdown);
        intervalEnemy = null;
        this.countdown = null;
        clearInterval(this.intervalBulletRight)
        this.intervalBulletRight = null;
        totalTimer = 90000
        this.events.off('buttonNext-dialogModal');
        setLastMovement('down');

        const members1 = ['jiu', 'sua', 'siyeon', 'handong', 'yoohyeon', 'dami', 'gahyeon'];
        const indexSelected = members1.findIndex(a => characterSelected === a);

        members1.splice(indexSelected, 1);

        let randomMembers = [];

        for (let i = 0; i < 2; i++) {
            let p;
            do {
                const num = Math.floor(Math.random() * 6);
                p = randomMembers.includes(num)
                if (!p) {
                    randomMembers.push(num);
                }
            }
            while (p);

        }

        const finalMembers = [];

        for (const r of randomMembers) {
            finalMembers.push(members1[r]);
        }

        allMembers = finalMembers;
        this.startAll = false;

    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();
    }

    create() {

        width = this.scale.width;
        const height = this.scale.height;
        const totalWidth = width * 20;

        const w = this.textures.get('fulltrip-mobile-game9').getSourceImage().width;
        const count = Math.ceil(totalWidth / w) * 2;
        let p = 0;
    
        for (let i = 0; i < count; i++) {
            const m = this.add.image(p, -30, 'fulltrip-mobile-game9')
                .setOrigin(1,0).setScale(2)
                .setScrollFactor(2)

            p += (m.width * 2);
        }

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        // this.dialogModal._createWindow(this, 'random-character-start', null, true)
        this.dialogModal._createImageDialog(this, 'random-character-start');
        this.showingInstruction = true;
        this.dialogModal.setText("Hey, I've been here before. \nThere are others around, but they're not the members I know. \nI need to stay safe and get out of here with my lightstick".toUpperCase(), `${characterSelected}-hallway`, false, false)

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }
            isPause = true;
            startKill = true;
            this.startAll = false;
        });

        this.events.on(`resume`, (data, args) => {
            if (args) {
                this.ppalSong.stop();
                this.scene.stop();
                if (args.goHome) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');
                    clearInterval(intervalEnemy);
                    intervalEnemy = null;
                    clearInterval(this.countdown);
                    this.countdown = null;
                    clearInterval(this.intervalBulletRight)
                    this.intervalBulletRight = null;

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true, lastCoordenates });
                }

                if (args.goStart) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');
                    clearInterval(intervalEnemy);
                    intervalEnemy = null;
                    clearInterval(this.countdown);
                    this.countdown = null;
                    clearInterval(this.intervalBulletRight)
                    this.intervalBulletRight = null;
                    this.scene.start(`Start`);
                }
            } else {
                isPause = false;
                this.sound.mute = false;

                if(!this.showingInstruction) {
                    this.startAll = true;
                    startKill = false;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if (!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });

        this.ppalSong = this.sound.add(`bocaSong`, { loop: false, volume: 0.2 });
        if (gameSettings === '1') {
            this.ppalSong.play();
        }

        upRectangle = this.add.rectangle(0, 0, width, 195).setOrigin(0).setScrollFactor(0);
        this.physics.add.existing(upRectangle);
        upRectangle.body.collideWorldBounds = true;

        downRectangle = this.add.rectangle(0, height, width, 10).setOrigin(0, 1).setScrollFactor(0);
        this.physics.add.existing(downRectangle);
        downRectangle.body.collideWorldBounds = true;

        leftRectangle = this.add.rectangle(0, 0, 70, height).setOrigin(0).setScrollFactor(0);
        this.physics.add.existing(leftRectangle);
        leftRectangle.body.collideWorldBounds = true;

        rightRectangle = this.add.rectangle(width, 0, 70, height).setOrigin(0).setScrollFactor(0);
        this.physics.add.existing(rightRectangle);
        rightRectangle.body.collideWorldBounds = true;

        this.countdownText = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 60, 16, 'pixelfont',`${this.convertTimer()}`.toUpperCase(), 10, 1).setTint(0xFFFFFF).setDepth(1).setOrigin(1, 0).setScrollFactor(0).setScale(1.5);
        this.countdownText.visible = false;

        objNames[characterSelected] = this.physics.add.sprite(((width / 2) + (width / 4)), 270, `${characterSelected}3-game9`, 4).setScrollFactor(0);
        objNames[characterSelected].body.setCollideWorldBounds(true);
        objNames[characterSelected].setScale(2);
        objNames[characterSelected].setImmovable();

        walkAnimation(this, `${characterSelected}3-game9`);
        reposeAnimation(this, `${characterSelected}3-game9`);
        rightStaticAnimation(this, `${characterSelected}3-game9`);
        lightstickAnimation(this, `${characterSelected}3-game9`);

        this.hp = new HealthBar(this, objNames[characterSelected].x - 490, objNames[characterSelected].y - 235);
        this.hp.setVisible(false);
        this.hp.setScrollFactor(0);

        this.deadSprite = this.physics.add.sprite(0, 0, `humo-game9`).setScale(2).setScrollFactor(0).setVisible(false);
        this.anims.create({
            key: `deadSpriteAnimation`,
            frames: this.anims.generateFrameNumbers('humo-game9', { start: 0, end: 17 }),
            frameRate: 8,
            repeat: -1
        });
        this.physics.add.collider(objNames[characterSelected], upRectangle);
        this.physics.add.collider(objNames[characterSelected], downRectangle);

        for (const [i, enemy] of allMembers.entries()) {
            let y = null;
            let x = null;
            switch (i) {
                case 0:
                    y = 260;
                    x = 40;
                    break;
                case 1:
                    y = 300;
                    x = 180;
                    break;
            }
            this.bulletRight[enemy] = this.physics.add.sprite(0, 0, `bullet-right-game9`).setScrollFactor(0).setVisible(false).setActive(false);
            this.enemies[enemy] = this.physics.add.sprite(x, y, `${enemy}-e-game9`).setScale(2).setScrollFactor(0).setVisible(false);

            walkAnimation(this, `${enemy}-e-game9`);
            this.physics.add.collider(this.enemies[enemy], upRectangle);
            this.physics.add.collider(this.enemies[enemy], downRectangle);

            this.physics.add.collider(this.bulletRight[enemy], objNames[characterSelected], () => {
                this.bulletRight[enemy].visible = false;
                this.deadSprite.visible = true;
                this.deadSprite.anims.play(`deadSpriteAnimation`, true);

                if (this.hp.decrease(10)) {
                    this.updateCounter();

                }

                setTimeout(() => {
                    this.deadSprite.visible = false;
                }, 500);
            }, null, this);
        }


        this.physics.add.collider(objNames[characterSelected], leftRectangle);
        this.physics.add.collider(objNames[characterSelected], rightRectangle);


        let x = 0;
        let y = 16;
        for (let i = 0; i < totalHearts; i++) {
            if (i === 0) {
                x += 40;
            } else {
                x += 30;
            }
            blackHeartsObject.push(this.add.image(x, y, `heartBlack`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
            redHeartsObject.push(this.add.image(x, y, `heartRed`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
        }

        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            if (data.id === 'random-character-start') {
                this.dialogModal.close();
                this.countdownText.visible = true;
                this.countdown = setInterval(() => {
                    if (!isPause) {
                        totalTimer -= 1000;
                    }
                    if (totalTimer <= 0) {
                        for (const enemy of allMembers) {
                            this.enemies[enemy].setActive(false);
                            this.enemies[enemy].setVisible(false);
                            this.bulletRight[enemy].setVelocity(0);
                            this.bulletRight[enemy].setActive(false);
                            this.bulletRight[enemy].setVisible(false);
                        }
                        clearTimeout(this.timeoutBullet);
                        clearInterval(this.intervalBulletRight);
                        clearInterval(intervalEnemy)
                        clearInterval(this.countdown);
                        this.startAll = false;
                        this.showingInstruction = true;
                        startKill = false;
                        this.intervalBulletRight = null;
                        intervalEnemy = null;
                        objNames[characterSelected].setVelocity(0);
                        this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                            setLastMovement('down');
                            objNames[characterSelected].anims.play(`repose-${characterSelected}3-game9`, true);
                            this.hp.setVisible(false);
                            this.countdownText.setVisible(false);
                            // objNames[characterSelected].setFrame(4);
                            // objNames[characterSelected].active = false;
                            if (progress === 1) {
                                objNames[characterSelected].setPosition(width / 2, 270);
                                // footsteps.stop();
                                this.cameras.main.fadeIn();
                                setTimeout(() => {
                                    // this.dialogModal._createWindow(this, 'random-character-finish', null, true)
                                    this.dialogModal._createImageDialog(this, 'random-character-finish');

                                    this.dialogModal.setText("I did it! \nNow, I just need to get out of here.".toUpperCase(), `${characterSelected}-hallway`, false, false)
                                }, 3000);
                            }
                        });
                    }
                }, 1000);
                this.startAll = true;

                 if(this.isMobile) {
                    this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}3-game9`, 300);
                    this.joystickManager.createJoystick();
                    this.joystickManager.activate(true);

                }
                instructionsHandler = 0;
                this.showingInstruction = false;
                this.hp.setVisible(true);
                intervalEnemy = setInterval(() => {
                    if (!startKill && !isPause) {
                        for (const [i, enemy] of allMembers.entries()) {
                            this.enemies[enemy].setVelocity(0, this.generateRandomNumber(-200, 200));
                        }

                    }

                }, 1000);

                this.intervalBulletRight = setInterval(() => {
                    if (!startKill && !isPause) {
                        for (const [i, enemy] of allMembers.entries()) {

                            this.timeoutBullet = setTimeout(() => {
                                this.bulletRight[enemy].setPosition(this.enemies[enemy].x + 20, this.enemies[enemy].y + 10);
                                this.bulletRight[enemy].setActive(true).setVisible(true);
                                this.bulletRight[enemy].setVelocity(700, 0);

                            }, this.getRandomInt(1500, 2000));
                        }
                    }
                }, 3000);
            }

            if (data.id === 'random-character-finish') {
                this.dialogModal.close();
                clearInterval(this.countdown);
                clearInterval(intervalEnemy)
                clearInterval(this.intervalBulletRight);
                intervalEnemy = null;
                this.intervalBulletRight = null;
                this.ppalSong.stop();
                this.scene.stop();
                this.events.off('buttonNext-dialogModal');
                if (hearts > 0) {
                    let total = JSON.parse(localStorage.getItem('noL'));
                    if (total) {
                        if (!total.includes(9)) {
                            total.push(9);
                            localStorage.setItem('noL', JSON.stringify(total));

                        }
                    } else {
                        localStorage.setItem('noL', JSON.stringify([9]));
                    }
                    this.scene.start(`Win`, { characterSelected: characterSelected, level: 9, lastCoordenates });
                } else {
                    this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 9, lastCoordenates });
                }
            }
        });

        if (this.isMobile) {

            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }


        this.lightstickCounter = new LightstickCounter(this);
        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);

        window.addEventListener("blur", () => {
            isPause = true;
            startKill = false;
            this.startAll = false;
            this.buttonPause.pauseByEvent();
        });

        // document.addEventListener('visibilitychange', () => {
        //     if (document.visibilityState !== 'visible') {
        //         isPause = true;

        //         this.startKill = false;
        //         this.startAll = false;
        //         this.buttonPause.pauseByEvent();
        //     }
        // });

    }

    getRandomInt(min, max) {
        const minCeiled = Math.ceil(min);
        const maxFloored = Math.floor(max);
        return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
    }

    convertTimer() {
        let seconds;
        let minutes;

        minutes = Math.floor((totalTimer / 60000));
        seconds = ((totalTimer % 60000) / 1000).toFixed(0);
        seconds = (seconds < 10 ? '0' : '') + seconds;

        return `${minutes} : ${seconds} ${minutes > 0 ? "MIN" : "SEG"}`;
    }

    updateCounter() {
        this.tweens.add({
            targets: redHeartsObject[hearts - 1],
            alpha: 0,
            scaleX: 0,
            scaleY: 0,
            ease: 'Linear',
            duration: 200
        });

        //create a timeline of tweens for the heart outline so it shrinks then grows back
        var heartsTimeline = this.tweens.createTimeline();

        //this is the heart outline scaling down
        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 1.5,
            scaleY: 1.5,
            ease: 'Power1',
            duration: 200
        });

        //and then back
        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 3,
            scaleY: 3,
            ease: 'Power1',
            duration: 200
        });
        //play the timeline straight away
        heartsTimeline.play();
        // redHeartsObject[hearts-1].destroy();
        hearts -= 1;
        if (hearts > 0) {
            this.hp.restartBar();
        }
        setTimeout(() => {
            if (hearts <= 0) {
                // this.timer.destroy();
                if(this.joystickManager) {
                    this.joystickManager.destroyTest();
                }
                clearInterval(intervalEnemy)
                clearInterval(this.intervalBulletRight)
                clearInterval(this.countdown);
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        // footsteps.stop();
                        intervalEnemy = null;
                        this.intervalBulletRight = null;
                        this.ppalSong.stop();
                        this.scene.stop();
                        this.events.off('buttonNext-dialogModal');
                        this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 9, lastCoordenates });
                    }
                });
            }
            // handleDamage = false;

        }, 1000);

    }

    generateRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }


    update() {

        const cam = this.cameras.main;
        let speed = 3;
        let speedMona = 100;
        if (this.startAll && !startKill) {

            if (this.countdownText.visible) {
                this.countdownText.setText(this.convertTimer());
            }

            if (objNames[characterSelected].active) {

                objNames[characterSelected].anims.play(`right-${characterSelected}3-game9`, true);

                if (this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                    // if (this.buttonTop.isDown) {
                    //     objNames[characterSelected].setVelocity(0, -200)
                    // }

                    // if (this.buttonDown.isDown) {
                    //     objNames[characterSelected].setVelocity(0, 200)

                    // }
                } else {
                    if (cursors.up.isDown) {
                        objNames[characterSelected].setVelocity(0, -200)
                    }

                    if (cursors.down.isDown) {
                        objNames[characterSelected].setVelocity(0, 200)
                    }
                }
            }

            this.hp.updatePosition(objNames[characterSelected].x - 150, objNames[characterSelected].y - 100);
            if (this.deadSprite.visible) {
                this.deadSprite.setPosition(objNames[characterSelected].x, objNames[characterSelected].y);
            }

            if (totalTimer > 0) {

                for (const [i, enemy] of allMembers.entries()) {
                    this.enemies[enemy].setVisible(true);

                    this.enemies[enemy].anims.play(`right-${enemy}-e-game9`, true);

                }

                if (this.isMobile) {
                    // if (this.buttonLeft.isDown) {
                    //     cam.scrollX -= speed
                    // } else {
                    cam.scrollX += speed;


                    // }
                } else {
                    // if (cursors.left.isDown) {
                    //     cam.scrollX -= speed
                    // } else {
                    cam.scrollX += speed;
                    // 
                    // }

                }

            } else {
                for (const enemy of allMembers) {
                    this.enemies[enemy].setVisible(false);
                    this.bulletRight[enemy].setActive(false);
                    this.bulletRight[enemy].setVisible(false);
                }
            }
        } else {
            if(this.isMobile) {
                if(this.joystickManager) {
                    this.joystickManager.pause();
                }
            }
        }

        // if (!this.isMobile && this.pauseButton.isDown) {
        //     startKill = false;
        //     this.startAll = false;
        //     isPause = true;
        //     this.scene.launch('Pause', { scene: 'Game9' });
        //     this.scene.pause();

        // }

    }

}